<template>
  <mask-layer class="img-frame" v-model="open">
    <div class="content">
      <img :src="url">
    </div>
  </mask-layer>
</template>
<script>
import MaskLayer from '@/components/MaskLayer'
export default {
  name: 'ImgFrame',
  components: {
    MaskLayer
  },
  data () {
    return {
      url: '',
      open: false
    }
  },
  methods: {
    showLayer (url) {
      this.url = url
      this.open = true
    }
  }
}
</script>
<style lang="less" scoped>
.img-frame {
  z-index: 10000;
}
.content {
  padding: 30px!important;
  background-color: #fff;
}
img {
  min-width: 500px;
  max-width: 1000px;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/ImgFrame/ImgFrame.vue